import { Auth } from 'aws-amplify'
import React, { useContext, useEffect, useState } from 'react'
import { Route, Switch } from 'react-router'

import { Card } from '../../components'
import { ProfileInfoForm } from '../../components/profile-info-form'
import { SecurityAndLogin } from '../../components/security-and-login/security-and-login'
import { SettingsMenu } from '../../components/settings-menu'
import { VerifyTwoFAInput } from '../../components/verify-2fa-code'
import { Paths } from '../../config/routes'
import { PROFILE_CONTEXT } from '../../contexts/settings/profile'
import { useUser } from '../../contexts/user/user-context'
import { authService } from '../../lib/auth-service'
import { Notify } from '../../lib/helpers'

export function UpdateProfile() {
    const [error, setError] = useState<string | null>(null)
    const [sentEmailTwoFA, setSentEmailTwoFA] = React.useState<boolean>(false)
    const { profile, loading }: any = useContext(PROFILE_CONTEXT)
    const { user, getCognitoUser } = useUser()

    useEffect(() => {
        //@ts-ignore
        if (!sentEmailTwoFA && user && !user.attributes.email_verified) {
            setSentEmailTwoFA(true)
            authService
                .resendCode('email')
                .then(success =>
                    console.log(
                        'Sent email cause the user didnt had the email verified',
                    ),
                )
        }
    }, [sentEmailTwoFA, user, setSentEmailTwoFA])

    if (!profile) {
        return null
    }

    return (
        <div className='grid grid-cols-5 grid-rows-2 lg:grid-rows-1 grid-flow-col gap-4 py-4 h-full'>
            <div className='col-span-5 lg:col-span-2 3xl:col-span-1'>
                <SettingsMenu />
            </div>
            <div className='col-span-5 lg:col-span-3  3xl:col-span-4'>
                <Card
                    className='w-full h-full flex overflow-auto'
                    loading={loading}>
                    {user &&
                    //@ts-ignore
                    (!user.attributes.email_verified ||
                        //@ts-ignore
                        !user.attributes.phone_number_verified) ? (
                        <VerifyTwoFAInput
                            error={error}
                            newValue={
                                //@ts-ignore
                                !user.attributes.email_verified
                                    ? //@ts-ignore
                                      user.attributes.email
                                    : //@ts-ignore
                                      user.attributes.phone_number
                            }
                            type={
                                //@ts-ignore
                                !user.attributes.email_verified
                                    ? 'email'
                                    : 'phone_number'
                            }
                            resendCode={async () => {
                                await authService.resendCode(
                                    //@ts-ignore
                                    !user.attributes.email_verified
                                        ? 'email'
                                        : 'phone_number',
                                )
                                Notify(
                                    'success',
                                    'Resend code',
                                    'Your code was sent successfully',
                                )
                            }}
                            confirmCode={async (type, code) => {
                                try {
                                    await authService.confirmAttributeByCode(
                                        //@ts-ignore
                                        !user.attributes.email_verified
                                            ? 'email'
                                            : 'phone_number',
                                        code,
                                    )
                                    await Auth.currentAuthenticatedUser({
                                        bypassCache: true,
                                    })
                                    getCognitoUser()
                                } catch (e) {
                                    setError('Invalid code')
                                    Notify(
                                        'danger',
                                        'Invalid code',
                                        'Your code was invalid, please try again',
                                    )
                                }
                            }}
                        />
                    ) : (
                        <Switch>
                            <Route path={Paths.UPDATE_PROFILE}>
                                <ProfileInfoForm emailAndPhone />
                            </Route>
                            <Route path={Paths.UPDATE_SECURITY}>
                                <SecurityAndLogin />
                            </Route>
                        </Switch>
                    )}
                </Card>
            </div>
        </div>
    )
}
